import { useEffect, useRef } from "react";

// Calls `onLock` after `ms` of no user activity while `active`. Uses a ref for
// the callback so frequent re-renders (e.g. incoming messages) don't reset the
// timer — only real input events do. Re-unlock is a tap, so a short idle window
// is cheap.
export function useIdleLock(active: boolean, onLock: () => void, ms = 15 * 60 * 1000): void {
  const cb = useRef(onLock);
  cb.current = onLock;
  useEffect(() => {
    if (!active) return;
    let timer: number;
    const reset = () => {
      clearTimeout(timer);
      timer = window.setTimeout(() => cb.current(), ms);
    };
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"] as const;
    events.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    // Also lock when the tab is hidden long enough (handled by the same timer).
    reset();
    return () => {
      clearTimeout(timer);
      events.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [active, ms]);
}
